<template>
  <!-- <div class="invoices">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar> -->
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row align-items-center">
              <div class="col">
                <h3 class="page-title">Alur Percakapan</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link to="/index">Dashboard</router-link>
                  </li>
                  <li class="breadcrumb-item">
                    <router-link to="/automation/text-reply/list">Text Reply</router-link>
                  </li>
                  <li class="breadcrumb-item active">Custom Rules</li>
                </ul>
              </div>
              <div class="col-auto float-right ml-auto">
                <a ref="formBc" class="btn add-btn" @click="showBroadcast(true)" href="#" data-toggle="modal"
                  data-target="#add_form">
                  <i class="fa fa-plus"></i> Tambah
                </a>
              </div>
              <a v-show="false" ref="formBcEdit" class="btn add-btn" @click="showBroadcast(false)" href="#"
                data-toggle="modal" data-target="#add_form">
                <i class="fa fa-whatsapp"></i> Edit
              </a>
            </div>
          </div>
          <!-- /Page Header -->

          <!-- Search Filter -->
          <div class="row filter-row">
            <div class="col-sm-6 col-md-6 ">
              <div class="form-group">
                <!-- <input
                  class="form-control floating"
                  v-model="serverParams.columnFilters.license_id"
                  type="text"
                />
                <label class="focus-label">License ID</label>-->

                <multiselect :class="'form-control'" v-model="selectedContact" id="ajax" label="license_name"
                  track-by="id" :placeholder="''" :multiple="true" open-direction="bottom" :custom-label="customLabel"
                  :options="contactOptions" :searchable="true" :loading="isLoading" :internal-search="false"
                  :close-on-select="false" :options-limit="300" style="width: 90%;" :limit="3" :limit-text="limitText"
                  :max-height="600" :show-no-results="true" :hide-selected="true" @search-change="loadTextReply"
                  :show-labels="false">
                  <template slot="tag" slot-scope="{ option, remove }">
                    <span class="custom__tag">
                      <span>{{ option.button_text + " (" + option.button_title + ")" }}</span>
                      <span class="custom__remove" @click="remove(option)">❌</span>
                    </span>
                  </template>
                  <template slot="clear" slot-scope="props">
                    <div class="multiselect__clear" v-if="selectedContact.length"
                      @mousedown.prevent.stop="clearAll(props.search)"></div>
                  </template>
                  <span slot="noResult">Oops! No elements found.</span>
                </multiselect>
              </div>
            </div>

            <div class="col-sm-6 col-md-3">
              <a href="javascript:void(0)" @click.prevent="searchData" class="btn btn-success btn-block">Search</a>
            </div>
          </div>
          <div class="row filter-row" v-if="selectedTable.length">
            <div class="col-sm-6 col-md-2">
              <div class="form-group">
                <button :disabled="isLoading" @click.prevent="actionDelete" class="btn btn-danger btn-block">
                  <i class="la la-trash"></i> Remove
                </button>
              </div>
            </div>
            <div class="col-sm-6 col-md-10">
              <div class="text-right">
                <!-- <button class="btn btn-success btn-block">Scrape</button>-->
                <a @click.prevent="hideActions" class="btn btn-xs">
                  <i class="fa fa-close"></i> Close
                </a>
              </div>
            </div>
          </div>
          <!-- /Search Filter -->
          <div class="row">
            <div class="col-md-12">
              <!-- {{currentDateTimeUnix()}} -->
              <div class="table-responsive">
                <table class="table table-striped custom-table mb-0">
                  <thead>
                    <tr>
                      <th>
                        <div class="checkbox">
                          <label>
                            <input type="checkbox" v-model="selectAllTable" />
                          </label>
                        </div>
                      </th>
                      <th style="width:20%;">Text Reply</th>
                      <th>Resp. Message</th>
                      <th style="width:20%;">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-if="loading">
                      <tr>
                        <td colspan="5">
                          <Skeleton :count="1" />
                        </td>
                      </tr>
                    </template>
                    <template v-if="rows.length">
                      <tr v-for="(row, index) in rows" :key="index">
                        <td>
                          <div class="checkbox">
                            <label>
                              <input type="checkbox" v-model="selectedTable" :value="row" />
                            </label>
                          </div>
                        </td>
                        <td>
                          <div class="user-add-shedule-list">
                            <a href="javascript:void(0)">{{ row.button_text }}</a>
                          </div>
                        </td>
                        <td class="text-wrap">
                          <div>{{ row.button_response }}</div>
                          <div style="font-size:12px;" class="text-muted">{{ row.footer_message }}</div>
                          <template v-if="row.btn_main.length">
                            <template v-if="row.button_type != 'list_text'">
                              <template v-if="row.button_type == 'text_reply'">
                                <div v-for="(rowVal, idx) in row.btn_main" :key="idx" class="user-add-shedule-list">

                                  {{ (idx + 1) + ". " + rowVal.button_text }}

                                </div>
                              </template>
                              <template v-else>
                                <div v-for="(rowVal, idx) in row.btn_main" :key="idx" class="user-add-shedule-list">
                                  <a href="javascript:void(0)">
                                    <i class="fa fa-tags" v-if="rowVal.button_type == 'button'"></i>
                                    <i class="fa fa-external-link" v-if="rowVal.button_type == 'url'"></i>
                                    <i class="fa fa-phone" v-if="rowVal.button_type == 'call'"></i>
                                    {{ rowVal.button_text }}
                                  </a>
                                </div>
                              </template>
                            </template>
                            <template v-else>
                              <table class="table table-nowrap">
                                <template v-for="(rowVal, idx) in row.btn_main">
                                  <tr :key="idx">
                                    <td>
                                      <label :for="idx">{{ rowVal.button_text }}</label>
                                    </td>
                                    <td>
                                      &nbsp;
                                      <input disabled name="radio_list_text" class="form-check-input" :id="idx"
                                        type="radio" />
                                    </td>
                                  </tr>
                                </template>
                              </table>
                            </template>
                          </template>
                        </td>
                        <td>
                          <div class="dropdown action-label">
                            <a class="btn btn-white btn-sm btn-rounded dropdown-toggle" href="#" data-toggle="dropdown"
                              aria-expanded="false">
                              <i class="fa fa-dot-circle-o text-danger"></i> Options
                            </a>
                            <div class="dropdown-menu dropdown-menu-right">
                              <!-- {{row.button_type}} -->
                              <a @click.prevent="detailData(row.header_id, row.button_type, row.button_response)"
                                class="dropdown-item">
                                <i class="fa fa-pencil text-success"></i> Edit
                              </a>
                              <a @click.prevent="deleteData(row.header_id)" class="dropdown-item">
                                <i class="fa fa-trash-o text-danger"></i> Remove
                              </a>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </template>
                    <template v-else-if="rows.length < 1 && !loading">
                      <tr>
                        <td colspan="4" class="text-center">-empty-</td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 col-md-6">
              <span class="footer__row-count__label">Displaying</span>
              <select @change="onPerPageChange(serverParams.perPage)" autocomplete="off" name="perPageSelect"
                v-model="serverParams.perPage" style="width: 100px;" class="select-to-paginasi">
                <option value="10">10 / page</option>
                <option value="20">20 / page</option>
                <option value="30">30 / page</option>
                <option value="40">40 / page</option>
                <option value="50">50 / page</option>
              </select>
              <span class="footer__row-count__label">of {{ totalRecords }} total records</span>
            </div>
            <div class="col-sm-12 col-md-6 text-right">
              <a href="javascript:void(0)" @click="onPrevChange(parseInt(currentPage))" tabindex="0" class="btn"
                :class="{ disabled: parseInt(currentPage) - 1 <= 0 }">
                <span class="chevron left"></span>
                <span>Prev</span>
              </a>
              page
              <input style="width:100px;" min="1" type="number" v-model="currentPage"
                @keyup.enter="onPageChange(parseInt(currentPage))" class />
              of {{ Math.ceil(totalRecords / serverParams.perPage) }}
              <a href="javascript:void(0)" @click="onNextChange(parseInt(currentPage))" tabindex="0"
                class="footer__navigation__page-btn" :class="'btn ' + {
                  disabled:
                    parseInt(currentPage) + 1 >
                    Math.ceil(totalRecords / serverParams.perPage)
                }">
                <span>Next</span>
                <span class="chevron right"></span>
              </a>
            </div>
          </div>
        </div>
        <!-- /Page Content -->
      <!-- </div> -->
      <!-- /Page Wrapper -->
    <!-- </div> -->

    <form-data :searchData="searchData" />

    <!-- {{selectedContact}} -->
  </div>
</template>

<script>
import {
  currentDateTimeUnix,
  formatLocalDate,
  nFormatter,
  getCurrentMonth,
  formatDate,
  labelStatusMessage,
  formatLocalDateWithDay,
  getWhatsappNumberFromJid
} from "@/utils/helper";
import { Skeleton } from "vue-loading-skeleton";
import FormData from "./form.vue";
import Multiselect from "vue-multiselect";
require("vue-multiselect/dist/vue-multiselect.min.css");

import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/SidebarChatbot.vue";
export default {
  components: {
    LayoutHeader,
    LayoutSidebar,
    Skeleton,
    Multiselect,
    FormData
  },
  data() {
    return {
      selectedTable: [],
      formParam: {
        header_id: "",
        button_type: "text_reply",
        button_response: "",
        detail_button: [
          {
            header_id: "",
            auto_reply_button_id: ""
          },
          {
            header_id: "",
            auto_reply_button_id: ""
          },
          {
            header_id: "",
            auto_reply_button_id: ""
          },
          {
            header_id: "",
            auto_reply_button_id: ""
          },
          {
            header_id: "",
            auto_reply_button_id: ""
          },
          {
            header_id: "",
            auto_reply_button_id: ""
          },
          {
            header_id: "",
            auto_reply_button_id: ""
          },
          {
            header_id: "",
            auto_reply_button_id: ""
          },
          {
            header_id: "",
            auto_reply_button_id: ""
          },
          {
            header_id: "",
            auto_reply_button_id: ""
          }
        ]
      },
      defaultDetailButton: 10,

      currentConditions: [],
      selectedContact: [],
      contactOptions: [],
      textReplyParams: {
        columnFilters: {
          title: "",
          is_publish: "publish",
        },
        page: 1,
        perPage: 500 // perPage
      },
      contactListParam: {
        columnFilters: { button_title: "", button_text: "" },
        page: 0,
        perPage: 20
      },
      isLoading: false,
      isShowModal: false,
      loading: false,
      rows: [],
      totalRecords: 0,
      currentPage: 1,
      rowPage: 1,
      serverParams: {
        columnFilters: {
          header_id: "",
          button_text: ""
        },
        page: 1,
        perPage: 20 // perPage
      }
    };
    //  isactive : true
  },
  watch: {
    selectedContact: {
      handler: function (val, oldVal) {
        // console.log("val.id", val.id, val.length);
        if (val.length > 1) {
          let lengthOld = oldVal.length;
          val.splice(0, 1);
          this.selectedLicense = val;
        }
        if (val.length == 1) {
          this.serverParams.columnFilters.header_id = val[0].id;
          this.searchData();
        } else {
          this.serverParams.columnFilters.header_id = "";
          this.searchData();
        }
        // if (val.id != "") {
        //   this.serverParams.columnFilters.license_id = val.id;
        //   // console.log("val.id", val.id);
        //   this.searchData();
        // } else {
        //   this.serverParams.columnFilters.license_id = "";
        //   this.searchData();
        // }
      },
      deep: true
    }
  },
  computed: {
    selectAllTable: {
      get: function () {
        return this.rows
          ? this.selectedTable.length == this.rows.length
          : false;
      },
      set: function (value) {
        var selectedTable = [];

        if (value) {
          this.rows.forEach(function (row) {
            // selectedTable.push(row.header_id);
            selectedTable.push(row);
          });
        }

        this.selectedTable = selectedTable;
      }
    }
  },
  created() {
    this.loadTextReply("");
    this.loadItems();
    this.currentPage = this.serverParams.page;
  },
  methods: {
    hideActions() {
      this.selectAllTable = false;
      this.selectedTable = [];
    },
    actionDelete() {
      if (this.selectedTable.length == 0) {
        this.$fire({
          title: "Error",
          text: "Please select at least one data",
          type: "error",
          timer: 2000
        });
        return;
      }
      this.isLoading = true;
      this.$fire({
        title:
          "Are you sure you want to permanently erase " +
          this.selectedTable.length +
          " messages?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `Cancel`
      })
        .then(async r => {
          if (r.value == true) {
            let newParam = {
              id: this.selectedTable
            };
            this.$store
              .dispatch("automation/actionDeleteCustomRules", newParam)
              .then(response => {
                this.$fire({
                  title: "Success Delete",
                  text: "The data was successfully deleted",
                  type: "success",
                  timer: 2000
                });
                this.isLoading = false;
                this.selectedTable = [];
                this.selectAllTable = false;

                this.searchData();
              })
              .catch(e => {
                this.isLoading = false;
              });
          } else {
            this.isLoading = false;
          }
        })
        .catch(e => {
          this.isLoading = false;
        });
    },
    async detailData(id, button_type, button_response) {
      this.$store.dispatch("automation/setIsShowForm", false);
      this.formParam.header_id = await id;
      this.formParam.button_type = await button_type;
      this.formParam.button_response = await button_response;
      this.formParam.detail_button = await [
        {
          header_id: id,
          auto_reply_button_id: ""
        },
        {
          header_id: id,
          auto_reply_button_id: ""
        },
        {
          header_id: id,
          auto_reply_button_id: ""
        },
        {
          header_id: id,
          auto_reply_button_id: ""
        },
        {
          header_id: id,
          auto_reply_button_id: ""
        },
        {
          header_id: id,
          auto_reply_button_id: ""
        },
        {
          header_id: id,
          auto_reply_button_id: ""
        },
        {
          header_id: id,
          auto_reply_button_id: ""
        },
        {
          header_id: id,
          auto_reply_button_id: ""
        },
        {
          header_id: id,
          auto_reply_button_id: ""
        }
      ];
      let newParam = {
        header_id: id,
        button_type: button_type,
        button_response: button_response,
        detail_button: []
      };
      console.log("newParam", newParam);
      await this.$store
        .dispatch("automation/detailCustomRules", id) // sesuai kan dengan method di API
        .then(response => {
          var { data } = response;
          console.log("dataaa", data);

          if (data.length) {
            newParam.detail_button = [];
            data.forEach((value, index) => {
              let newData = {};
              newData = {
                header_id: value.header_id,
                auto_reply_button_id: value.auto_reply_button_id
              };
              // console.log("newData", newData);

              newParam.detail_button.push(newData);
            });
          }
        });
      if (newParam.detail_button.length < this.defaultDetailButton) {
        let kekuranganBtn =
          (await this.defaultDetailButton) - newParam.detail_button.length;
        for (var i = 0; i < kekuranganBtn; i++) {
          await newParam.detail_button.push({
            header_id: id,
            auto_reply_button_id: ""
          });
        }
      }
      await this.$store.dispatch(
        "automation/actFormParamCustomRules",
        newParam
      );
      // this.showBroadcast();
      var elem = await this.$refs.formBcEdit;
      await elem.click();
      // console.log("this.formParam.detail_button", this.formParam.detail_button);
    },
    limitText(count) {
      return `and ${count} other`;
    },
    customLabel({ title, message }) {
      // return `${title} (${message})`;
      return `${title}`;
    },
    loadTextReply(query) {
      this.isLoading = true;
      this.textReplyParams.page = 0;
      this.textReplyParams.columnFilters.title = query;
      this.$store
        .dispatch("automation/listTextReply", this.textReplyParams)
        .then(response => {
          this.isLoading = false;
          this.contactOptions = response.data.data;
        }) // sesuai kan dengan method di API
        .catch(error => {
          this.isLoading = false;
        });
    },
    asyncFind(query) {
      this.isLoading = true;
      this.contactListParam.columnFilters.button_text = query;
      this.$store
        .dispatch("automation/listReplyButtons", this.contactListParam)
        .then(response => {
          this.isLoading = false;
          this.contactOptions = response.data.data;
        }) // sesuai kan dengan method di API
        .catch(error => {
          this.isLoading = false;
        });
    },
    clearAll() {
      this.selectedContact = [];
    },

    deleteData(headerId) {
      this.$fire({
        title: "Are you sure you will delete this data?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `Cancel`
      }).then(async r => {
        if (typeof r.value != "undefined" && r.value == true) {
          this.$store
            .dispatch("automation/deleteCustomRules", headerId) // sesuai kan dengan method di API
            .then(response => {
              this.searchData();
              this.$fire({
                title: "Success",
                text: response["msg"],
                type: "success",
                timer: 2000
              });
            });
        }
      });
    },
    showBroadcast(newData) {
      if (typeof newData != "undefined" && newData == true) {
        this.$store.dispatch("automation/setIsShowForm", false);

        let formData = {
          header_id: "",
          detail_button: [
            {
              header_id: "",
              auto_reply_button_id: ""
            },
            {
              header_id: "",
              auto_reply_button_id: ""
            },
            {
              header_id: "",
              auto_reply_button_id: ""
            },
            {
              header_id: "",
              auto_reply_button_id: ""
            },
            {
              header_id: "",
              auto_reply_button_id: ""
            },
            {
              header_id: "",
              auto_reply_button_id: ""
            },
            {
              header_id: "",
              auto_reply_button_id: ""
            },
            {
              header_id: "",
              auto_reply_button_id: ""
            },
            {
              header_id: "",
              auto_reply_button_id: ""
            },
            {
              header_id: "",
              auto_reply_button_id: ""
            }
          ]
        };
        this.$store.dispatch("automation/actFormParamCustomRules", formData);
      }
      var that = this;
      setTimeout(function () {
        var liContainer = document.getElementById("add_form");
        var isShowModal = liContainer.classList.contains("show");
        // console.log("isShowModal", isShowModal);
        // this.$root.$emit("infiniteHandlerContact");
        if (isShowModal == true) {
          that.$store.dispatch("automation/setIsShowForm", true);
        }
      }, 1000);
    },

    updateParams(newProps) {
      // console.log("newprops", newProps);
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },
    async onPageChange(page) {
      await this.updateParams({ page: page });
      this.currentPage = page;
      await this.loadItems();
    },
    async onNextChange(page) {
      if (
        page + 1 <=
        Math.ceil(this.totalRecords / this.serverParams.perPage)
      ) {
        await this.updateParams({ page: page + 1 });
        this.currentPage = page + 1;
        await this.loadItems();
      }
    },
    async onPrevChange(page) {
      // console.log("this.currentPage:: ", this.currentPage);
      if (this.currentPage == 1) {
        return;
      }
      if (
        page - 1 <=
        Math.ceil(this.totalRecords / this.serverParams.perPage)
      ) {
        await this.updateParams({ page: page - 1 });
        this.currentPage = page - 1;
        await this.loadItems();
      }
    },
    async onPerPageChange(params) {
      await this.updateParams({
        page: this.currentPage,
        perPage: this.serverParams.perPage
      });
      await this.loadItems();
    },
    formatDate(value) {
      return formatDate(value);
    },
    getCurrentMonth() {
      return getCurrentMonth();
    },
    nFormatter(value) {
      return nFormatter(value);
    },
    async searchData() {
      // this.currentPage = await 1;
      // this.serverParams.columnFilters.page = await 1;
      // await this.getListData();

      this.currentPage = 1;
      this.rows = await [];
      this.loading = await true;
      this.totalRecords = await 0;
      var params = await { page: this.currentPage };
      await this.updateParams(params);
      await this.loadItems();
      this.loading = await false;
    },
    async loadItems() {
      this.loading = await true;
      this.serverParams.page =
        this.serverParams.page - 1 <= 0
          ? await 0
          : await ((this.serverParams.page - 1) * this.serverParams.perPage);

      await this.$store
        .dispatch("automation/listCustomRules", this.serverParams) // sesuai kan dengan method di API
        .then(response => {
          const { data } = response;
          this.totalRecords = data.totalRecords;
          this.rowPage = data.page;
          this.rows = data.data;
          // console.log("rows", this.rows);
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  mounted() {
    if ($(".datetimepicker").length > 0) {
      $(".datetimepicker").datetimepicker({
        format: "DD/MM/YYYY",
        icons: {
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          next: "fa fa-angle-right",
          previous: "fa fa-angle-left"
        }
      });
    }

    // Select 2
    if ($(".select").length > 0) {
      $(".select").select2({
        minimumResultsForSearch: -1,
        width: "100%"
      });
    }
    // Multiselect
    if ($("#customleave_select").length > 0) {
      $("#customleave_select").multiselect();
    }
    if ($("#edit_customleave_select").length > 0) {
      $("#edit_customleave_select").multiselect();
    }

    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function (e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "broadcast-list"
};
</script>


// WEBPACK FOOTER //
// src/views/automation/customRulesText/list.vue